"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const handleKeyPressSpace = e => {
    if (e.key === 'Spacebar' || e.key === ' ') {
        e.preventDefault();
    }
};
exports.default = handleKeyPressSpace;
